import React from "react";
import type { BaseProvinceIconProps } from "./BaseProvinceIcon";

export const SaskatchewanIcon = (props: BaseProvinceIconProps) => {
  return (
    <path
      id="SK"
      {...props}
      d="M106.8,184.4c0.2,0,0.4,0,0.6,0.1c1.6,0.3,5.3,0.9,8.1,1.4c2,0.3,3.9,0.5,5.9,0.5c0.6,0,1.1,0,1.7,0
        l6.1-0.3c0,0,0.7,0,1,0c0.7,0,1.2,0.5,1.2,1.2c0,9.6,0.1,19,0,28.4c-0.1,15.9-0.3,31.9-0.4,47.8c0,2.2,0,2.3-2.3,2.3
        c-4.8,0-9.7,0-14.5,0c-3.7,0-14.6-0.6-16.4-0.9c-1.1-0.2-1-1-0.9-1.7c0.6-4.8,1.2-9.7,1.7-14.5c0.9-8.1,1.9-16.2,2.8-24.3
        c0.9-8,1.9-16,2.8-24c0.6-4.8,1.2-9.6,1.6-14.3C105.9,184.8,106.1,184.3,106.8,184.4L106.8,184.4z"
    />
  );
};
